import { grayColor, whiteColor, textColorWeak } from "assets/jss/default/theme";

const styles = theme => ({
  editor: {
    justifyContent: "flex-end",
    boxSizing: "border-box",
    background: "#fefefe",
    border: [[1, "solid", grayColor[5]]],
    borderRadius: 2,
    "& .DraftEditor-root": {
      padding: theme.spacing(1),
      overflowY: "hidden",
      cursor: "text",
      minHeight: props => (props.isExtendedEditor ? 140 : 1),
      boxSizing: "border-box",
      border: [[1, "solid", "rgba(0, 0, 0, 0)"]]
    },
    "& .DraftEditor-root:focus-within": {
      border: [[1, "solid", theme.palette.primary.main]]
    },
    "& .DraftEditor-root:hover:not(:focus-within)": {
      border: [[1, "solid", grayColor[5]]]
    },
    "& .public-DraftEditor-content": {
      minHeight: 1
    }
  },
  counter: {
    textAlign: "right",
    marginBottom: 10,
    marginTop: 10,
    paddingRight: 5,
    fontSize: 14,
    color: textColorWeak
  },
  options: {
    marginTop: 15
  },
  headlineButtonWrapper: {
    display: "inline-block"
  },
  headlineButton: {
    background: "#fbfbfb",
    color: "#888",
    fontSize: 18,
    border: 0,
    paddingTop: 5,
    verticalAlign: "bottom",
    height: 34,
    width: 36,
    "&:hover, &:focus": {
      background: "#f3f3f3"
    }
  }
});

export const toolbarStyles = {
  toolbar: {
    background: whiteColor,
    borderRadius: 2,
    zIndex: 2,
    "&:after": {
      borderColor: "rgba(255, 255, 255, 0)",
      borderTopColor: whiteColor,
      borderWidth: 4,
      marginLeft: -4
    },
    "&:before": {
      borderColor: "rgba(221, 221, 221, 0)",
      borderTopColor: grayColor[5],
      borderWidth: 6,
      marginLeft: -6
    }
  }
};

export const toolbarButtonStyles = {
  buttonWrapper: {
    display: "inline-block"
  },
  button: {
    background: grayColor[12],
    color: grayColor[0],
    fontSize: 18,
    border: 0,
    paddingTop: 5,
    verticalAlign: "bottom",
    height: 37,
    width: 36,
    "&:hover, &:focus": {
      background: grayColor[13],
      outline: 0 /* reset for :focus */
    },
    "& svg": {
      fill: grayColor[0]
    }
  },
  active: {
    background: grayColor[11],
    color: grayColor[6],
    "& svg": {
      fill: grayColor[6]
    }
  }
};

export default styles;
